import { combineReducers } from 'redux';

import { getReducer as getAbtestingReducer } from '@pegasus/abtesting';
import { getFlashMessagesReducer } from '../flash-messages/redux';
import { getCartReducer } from '../../Header/cart/redux/cart';
import { getRecoveredCartReducer } from '../../Header/cart/redux/recovered-cart';
import { getFooterReducer } from '../../Footer/redux';
import { getCustomerReducer } from '../../Header/customer/redux/customer';

export const reducer = combineReducers({
    ...getAbtestingReducer(),
    ...getFlashMessagesReducer(),
    ...getCartReducer(),
    ...getRecoveredCartReducer(),
    ...getFooterReducer(),
    ...getCustomerReducer(),
});
